import _jsx from "@babel/runtime/helpers/jsx";
import React from 'react';
import { Icon } from './index';
var SkholeIcon22 = Icon( /*#__PURE__*/_jsx("svg", {
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 40 40",
  style: {
    enableBackground: 'new 0 0 40 40'
  },
  xmlSpace: "preserve"
}, void 0, /*#__PURE__*/_jsx("path", {
  className: "st1",
  d: "M34.6,18L9.2,3.1C8.8,2.9,8.3,2.7,7.8,2.7c-0.5,0-1,0.1-1.4,0.4C5.5,3.6,5,4.5,5,5.5v28.9c0,1,0.5,1.9,1.4,2.4 c0.4,0.3,0.9,0.4,1.4,0.4c0.5,0,0.9-0.1,1.4-0.4l25.4-14.1c0.9-0.5,1.4-1.4,1.4-2.4C36,19.4,35.5,18.5,34.6,18z M33.3,20.7L7.9,34.7 c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2,0c-0.1-0.1-0.1-0.1-0.1-0.3V5.5c0-0.1,0-0.2,0.2-0.3c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.2,0 l25.4,14.8c0.1,0.1,0.2,0.1,0.1,0.3C33.5,20.5,33.5,20.6,33.3,20.7z"
})));
export default SkholeIcon22;